import { defineRouting } from "next-intl/routing";

// Configuración central de i18n. `as-needed` significa que el locale
// default (español) no aparece en la URL — solo aparece cuando el
// usuario está en inglés (/en/...). Esto preserva el SEO actual y
// hace la migración no-disruptiva.
export const routing = defineRouting({
  locales: ["es", "en"],
  defaultLocale: "es",
  localePrefix: "as-needed",
  localeDetection: false,
  // Cookie NEXT_LOCALE con flags seguros. `secure` solo en prod/dev
  // (HTTPS); en local (http://localhost) quedaría sin setear, lo cual
  // es inocuo (cae al defaultLocale).
  localeCookie: {
    secure: process.env.NODE_ENV === "production",
    sameSite: "lax",
    // httpOnly NO es opción soportada por next-intl localeCookie; se
    // fuerza en el middleware re-seteando NEXT_LOCALE tras intlMiddleware.
  },
});

export type Locale = (typeof routing.locales)[number];
